import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Skeleton } from '@components/ui';

import baseStyles from './ProductOnboardingCard.module.scss';
import styles from './ProductOnboardingCardSkeleton.module.scss';

const ProductOnboardingCardSkeleton = (props) => {
  const { className } = props;

  return (
    <div
      className={classnames(
        baseStyles.root,
        styles.root,
        className
      )}
    >
      <div
        className={classnames(
          baseStyles.imageContainer,
          styles.imageContainerSkeleton
        )}
      >
        <Skeleton circle className={styles.imageSkeleton} />
      </div>
      <div
        className={classnames(
          baseStyles.details,
          styles.detailsContainerSkeleton
        )}
      >
        <Skeleton count={2} containerClassName={styles.detailsSkeleton} />
      </div>
    </div>
  );
};

ProductOnboardingCardSkeleton.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};

export default ProductOnboardingCardSkeleton;
